import { LeavePageModal } from '@adotel/components'
import { useLazyQuery, useMutation } from '@apollo/client'
import { CircularProgress, Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Step from '@material-ui/core/Step'
import StepConnector from '@material-ui/core/StepConnector'
import { StepIconProps } from '@material-ui/core/StepIcon'
import StepLabel from '@material-ui/core/StepLabel'
import Stepper from '@material-ui/core/Stepper'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import ContractIcon from '@material-ui/icons/Assignment'
import Check from '@material-ui/icons/Check'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import apolloClient from '../../graphql/apolloClient'
import {
  CONTRACT_QUERY,
  GENERATE_CONTRACT_MUTATION,
  MODIFY_CONTRACT_MUTATION
} from '../../graphql/contracts'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate, lang } from '../../localization'
import contractPagesRoleManagement from '../../staticRoleManagement/contractRoleManagement'
import { ROLE } from '../../staticRoleManagement/types'
import { AccommodationDataWithRatePlans } from '../../types/accommodation'
import { ContractInput, Contract } from '../../types/contract'
import ContractFormStepOne from './ContractFormStepOne'
import { ContractFormStepThree } from './ContractFormStepThree'
import { ContractFormStepTwo } from './ContractFormStepTwo'
import useStyles from './styles/index.styles'

const QontoConnector = withStyles((theme) => ({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)'
  },
  active: {
    '& $line': {
      borderColor: theme.palette.primary.main
    }
  },
  completed: {
    '& $line': {
      borderColor: theme.palette.primary.main
    }
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1
  }
}))(StepConnector)

const useQontoStepIconStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    display: 'flex',
    height: 22,
    alignItems: 'center'
  },
  active: {
    color: theme.palette.primary.main
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor'
  },
  completed: {
    color: theme.palette.primary.main,
    zIndex: 1,
    fontSize: 18
  }
}))

function QontoStepIcon(props: StepIconProps) {
  const classes = useQontoStepIconStyles()
  const { active, completed } = props

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active
      })}>
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  )
}

function getSteps() {
  return [
    getTranslate('Choose Template'),
    getTranslate('Select Entities'),
    getTranslate('Contract Details')
  ]
}

function getStepContent(
  step: number,
  contract: ContractInput,
  setcontract: (c: ContractInput) => void,
  providerCodeForGenerate: string,
  setProviderCodeForGenerate: (c: string) => void,
  selectedTemplate: string,
  setselectedTemplate: (c: string) => void,
  loadingForContract: boolean,
  accommodationsData: AccommodationDataWithRatePlans[],
  setAccommodationsData: React.Dispatch<
    React.SetStateAction<AccommodationDataWithRatePlans[]>
  >,
  isRoleProvider: boolean,
  isRoleAccommodation: boolean
) {
  switch (step) {
    case 0:
      return (
        <ContractFormStepOne
          selectedTemplate={selectedTemplate}
          setselectedTemplate={setselectedTemplate}
          providerCodeForGenerate={providerCodeForGenerate}
          setProviderCodeForGenerate={setProviderCodeForGenerate}
          isRoleProvider={isRoleProvider}
          isRoleAccommodation={isRoleAccommodation}
        />
      )
    case 1:
      return (
        <ContractFormStepTwo
          loadingForContract={loadingForContract}
          contract={contract}
          setcontract={setcontract}
          accommodationsData={accommodationsData}
          setAccommodationsData={setAccommodationsData}
          providerCodeForGenerate={providerCodeForGenerate}
          isRoleAccommodation={isRoleAccommodation}
        />
      )
    case 2:
      return (
        <ContractFormStepThree contract={contract} setcontract={setcontract} />
      )
    default:
      return 'Unknown step'
  }
}

const ContractForm = () => {
  const classes = useStyles()
  const history = useHistory()
  const {
    providercode: providercodeParams,
    templateID,
    ID
  } = useParams<{
    providercode: string
    templateID: string
    ID: string
  }>()
  const [activeStep, setActiveStep] = useState(ID ? 1 : 0)
  const [contract, setcontract] = useState<ContractInput>({
    Active: false,
    Channels: [],
    From: '',
    RatePlans: [],
    Title: '',
    To: ''
  })

  const [selectedTemplate, setselectedTemplate] = useState<string>('')

  const [providerCodeForGenerate, setProviderCodeForGenerate] =
    useState<string>('')

  const [accommodationsData, setAccommodationsData] = useState<
    AccommodationDataWithRatePlans[]
  >([])

  const validAccommodationsRoles = [
    ROLE.ACCOMMODATION,
    ROLE.ACCOMMODATION_OPERATOR
  ]

  const isRoleProvider = getRoleFromStorage() === ROLE.PROVIDER

  const isRoleAccommodation = validAccommodationsRoles.some(
    (role) => role === getRoleFromStorage()
  )

  const steps = getSteps()

  const handleNext = () => {
    if (activeStep === 1) {
      const selectedRatePlans = accommodationsData
        .map(
          (acc) =>
            acc.ratePlans
              ?.filter((rp) => rp.selected)
              .map((rp) => ({
                PropertyCode: acc.value,
                RatePlanCode: rp.displayRatePlanCode || '',
                RoomTypeCode: rp.displayRoomTypeCode || ''
              })) || []
        )
        .flat()
      setcontract((currentContract) => ({
        ...currentContract,
        RatePlans: selectedRatePlans
      }))
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }
  const [getContract, { data, loading: loadingForContract }] = useLazyQuery<{
    contract: Contract
  }>(CONTRACT_QUERY, {
    notifyOnNetworkStatusChange: true
  })

  useEffect(() => {
    if (ID && templateID) {
      setselectedTemplate(templateID)
      getContract({
        variables: {
          providerCode: providercodeParams,
          templateID: templateID,
          contractID: ID
        },
        onCompleted: (resp) => {
          setcontract({
            Active: resp.contract.Active,
            From: resp.contract.From,
            Channels: resp.contract.Channels,
            RatePlans: resp.contract.RatePlans,
            Title: resp.contract.Title,
            To: resp.contract.To
          })
        },
        fetchPolicy: 'network-only'
      })
    }
  }, [])

  useEffect(() => {
    if (data?.contract) {
      setcontract({
        Active: data.contract.Active,
        From: data.contract.From,
        Channels: data.contract.Channels,
        RatePlans: data.contract.RatePlans,
        Title: data.contract.Title,
        To: data.contract.To
      })
    }
  }, [loadingForContract, data])

  const [onSubmitForContract, { loading: loadingForModfiyOrGenerate }] =
    useMutation(
      providercodeParams ? MODIFY_CONTRACT_MUTATION : GENERATE_CONTRACT_MUTATION
    )

  function removeDisplayFields<T extends object>(obj: T): T {
    const clone: any = Array.isArray(obj) ? [] : {}

    for (const key in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, key)) continue

      // Skip all Display* fields
      if (key.toLowerCase().startsWith('display')) continue

      const value = (obj as any)[key]

      // recurse arrays and objects
      if (Array.isArray(value)) {
        clone[key] = value.map((item) => removeDisplayFields(item))
      } else if (value && typeof value === 'object') {
        clone[key] = removeDisplayFields(value)
      } else {
        clone[key] = value
      }
    }

    return clone
  }

  const onSaveTemplate = async () => {
    const cleanedContract = removeDisplayFields(contract)

    await onSubmitForContract(
      providercodeParams
        ? {
            variables: {
              input: cleanedContract,
              providerCode: providercodeParams,
              templateID: templateID,
              contractID: ID
            }
          }
        : {
            variables: {
              input: cleanedContract,
              providerCode: providerCodeForGenerate,
              templateID: selectedTemplate
            }
          }
    )
      .then(({ data: response }) => {
        if (providercodeParams) {
          toast.success(response.modifyContract.message)
        } else {
          toast.success(response.generateContract.message)
        }
        apolloClient.cache.evict({ fieldName: 'contracts' })
        history.push(`/${lang}/contracts/list`)
      })
      .catch((err) => toast.error(err.message))
  }

  const hasAccessToModifyContract = contractPagesRoleManagement
    .find(
      (item) =>
        item.route ===
        '/contracts/provider/:providercode/:providerID/template/:templateID/contract/:ID'
    )
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  const hasAccessToCreateNewContract = contractPagesRoleManagement
    .find((item) => item.route === '/contracts/list/create')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <div className={classes.root}>
      <LeavePageModal />
      <div className={classes.header}>
        <ContractIcon fontSize="large" />
        <Typography className={classes.title} variant="h3" gutterBottom>
          {getTranslate(ID ? 'Modify Contract' : 'Create New Contract')}
        </Typography>
      </div>{' '}
      <Stepper
        className={classes.stepper}
        alternativeLabel
        activeStep={activeStep}
        connector={<QontoConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div className={classes.stepsContentContainer}>
        {getStepContent(
          activeStep,
          contract,
          setcontract,
          providerCodeForGenerate,
          setProviderCodeForGenerate,
          selectedTemplate,
          setselectedTemplate,
          loadingForContract,
          accommodationsData,
          setAccommodationsData,
          isRoleProvider,
          isRoleAccommodation
        )}
        <div className={classes.formButtonsContainer}>
          <Button
            disabled={
              activeStep === 0 ||
              !selectedTemplate ||
              (!!ID && activeStep === 1)
            }
            onClick={handleBack}
            className={classes.button}>
            {getTranslate('Back')}
          </Button>
          <Button
            disabled={
              !selectedTemplate ||
              !hasAccessToModifyContract ||
              !hasAccessToCreateNewContract ||
              loadingForModfiyOrGenerate ||
              (activeStep === steps.length - 1 &&
                (!contract.From ||
                  !contract.To ||
                  !contract.Title ||
                  !(contract.Channels.length > 0))) ||
              (activeStep === 1 && loadingForContract)
            }
            variant="contained"
            color="primary"
            onClick={() => {
              if (activeStep === steps.length - 1) {
                onSaveTemplate()
              } else {
                handleNext()
              }
            }}
            className={classes.button}>
            {activeStep === steps.length - 1
              ? getTranslate('Finish')
              : getTranslate('Next')}
            {loadingForModfiyOrGenerate && (
              <CircularProgress
                className={classes.circularProgress}
                size={16}
              />
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ContractForm
